var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85316 16.3275V11.3275H12.2042V16.3275C12.2042 16.8775 12.6936 17.3275 13.2919 17.3275H16.5552C17.1534 17.3275 17.6429 16.8775 17.6429 16.3275V9.3275H19.4921C19.9925 9.3275 20.2318 8.7575 19.8511 8.4575L10.7575 0.927501C10.3441 0.587501 9.71321 0.587501 9.29986 0.927501L0.206263 8.4575C-0.163573 8.7575 0.0648552 9.3275 0.565221 9.3275H2.4144V16.3275C2.4144 16.8775 2.90389 17.3275 3.50215 17.3275H6.7654C7.36367 17.3275 7.85316 16.8775 7.85316 16.3275Z",
    fill: "#CF1322"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRed);
export default __webpack_public_path__ + "static/media/homeRed.4d9533ef0bd0ab728a9a2465105556cd.svg";
export { ForwardRef as ReactComponent };